angular.module('elfium').filter('businessCaseLastStage', ['reportContentService', 'BUSINESS_CASE_STATES', 'REPORT_PHASE',
    function (reportContentService, BUSINESS_CASE_STATES, REPORT_PHASE) {
        var that = this;
        that.reportPhaseOrder = [REPORT_PHASE.OTEVRENI_PRIPADU, REPORT_PHASE.DOMLUV_PRVNI_SCHUZKA, REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA, REPORT_PHASE.CHCI_NABIDKU, REPORT_PHASE.PRVNI_PREDANI_NABIDKY, REPORT_PHASE.ROZHODNUTI_O_NABIDCE, REPORT_PHASE.ZADANI_DO_PT];
        that.buildLastStage = function (taskType, reportPhase, reportDto) {
            return {
                taskType: taskType,
                reportPhase: reportPhase,
                date: reportDto.date,
                volume: reportDto.volume ? parseInt(reportDto.volume) : ''
            };
        };
        that.getStageWithHighestDate = function (stages) {
            var newestStage = null;
            for (var i = 0; i < stages.length; ++i) {
                if (!newestStage || newestStage.date <= stages[i].date) {
                    newestStage = stages[i];
                }
            }
            return newestStage;
        };
        return function (reportsDto) {
            var lastStage = null;
            var reportsDtoKeys = Object.keys(reportsDto);
            for (var i = 0; i < reportsDtoKeys.length; ++i) {
                var taskType = reportsDtoKeys[i];
                var reportPhases = reportsDto[taskType];
                for (var j = 0; j < that.reportPhaseOrder.length; ++j) {
                    var reportPhaseName = that.reportPhaseOrder[j];
                    var reportPhase = reportPhases[reportPhaseName];
                    if (reportPhase) {
                        var stageWithHighestDate = that.getStageWithHighestDate(reportPhase.actual);
                        lastStage = that.buildLastStage(taskType, reportPhaseName, stageWithHighestDate);
                        if (!stageWithHighestDate.isLocked) {
                            return lastStage;
                        }
                    }
                }
            }
            return lastStage;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseLastStageFilter.ts